import script from "./Bookings.vue?vue&type=script&setup=true&lang=js"
export * from "./Bookings.vue?vue&type=script&setup=true&lang=js"

import "./Bookings.vue?vue&type=style&index=0&id=50a2b4c6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a2b4c6"]])

export default __exports__